import { BehaviorSubject, Observable } from 'rxjs';
import { AsyncPipe, TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, viewChild } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { inject } from '@angular/core';
import { Popover, PopoverModule } from 'primeng/popover';
import { AvatarModule } from 'primeng/avatar';
import { ShortNamePipe } from '@fitness-force/pipes/short-name';

@Component({
  selector: 'client-info-report',
  templateUrl: './client-info-report.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    AvatarModule,
    PopoverModule,
    RouterModule,
    ShortNamePipe,
    AsyncPipe,
    TitleCasePipe,
  ],
})
export class ClientInfoReportComponent {
  private readonly router = inject(Router);

  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);

  readonly op = viewChild<Popover>('op');

  show = (event: Event) => this.op()?.show(event);
  hide = () => this.op()?.hide();

  isEmptyOrNull(value: any): boolean {
    if (value === null || value === undefined) return true;
    if (typeof value === 'string') return value.trim() === '';
    return false;
  }

  gotoClient(id: any): void {
    if (id) this.router.navigate(['/client/profile/', id]);
  }
}
